const AZURE_BLOB_HOST_SUFFIX = ".blob.core.windows.net";
const SHAREPOINT_TENANT_HOST = "smsgroupgmbh.sharepoint.com";

function parseHttpsUrl(value: unknown): URL | undefined {
  if (typeof value !== "string" || value.trim() !== value || value.length === 0) {
    return undefined;
  }

  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || !url.hostname || url.username || url.password || url.port) {
      return undefined;
    }
    return url;
  } catch {
    return undefined;
  }
}

/**
 * Validate a legacy Azure Blob image URL by its parsed hostname, not by a
 * substring in the URL (which could appear in its path, query, or user info).
 */
export function getSafeAzureBlobUrl(value: unknown): string | undefined {
  const url = parseHttpsUrl(value);
  if (!url || !url.hostname.endsWith(AZURE_BLOB_HOST_SUFFIX)) {
    return undefined;
  }

  const accountName = url.hostname.slice(0, -AZURE_BLOB_HOST_SUFFIX.length);
  if (!/^[a-z0-9]{3,24}(?:-secondary)?$/.test(accountName)) {
    return undefined;
  }

  return url.href;
}

/**
 * Only allow links to the tenant's HTTPS SharePoint host. Persisted values are
 * treated as untrusted even though the edit form also validates user input.
 */
export function getSafeSharePointUrl(value: unknown): string | undefined {
  const url = parseHttpsUrl(value);
  if (!url || url.hostname !== SHAREPOINT_TENANT_HOST) {
    return undefined;
  }
  return url.href;
}
